import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import State from 'store/State';

export interface NewportVersionDetails {
    minRequiredNewportVersion: string;
    minRecommendedNewportVersion: string;
    clientNewportVersion: string;
    hasMinimumRequiredNewportVersion: boolean;
    hasMinimumRecommendedNewportVersion: boolean;
}

export interface NewportAppState {
    versionDetails?: NewportVersionDetails;
    hasMinimumRequiredNewportVersionDismissed: boolean;
    hasMinimumRecommendedNewportVersionDismissed: boolean;
}

export const initialNewportAppState: NewportAppState = {
    hasMinimumRecommendedNewportVersionDismissed: false,
    hasMinimumRequiredNewportVersionDismissed: false,
};

const newportAppSlice = createSlice({
    name: 'newportApp',
    initialState: initialNewportAppState,
    reducers: {
        setVersionDetails: (
            state,
            action: PayloadAction<NewportVersionDetails>
        ) => {
            state.versionDetails = action.payload;
        },
        dismissHasMinimumRecommendedNewportVersion: (state) => {
            state.hasMinimumRecommendedNewportVersionDismissed = true;
        },
        dismissHasMinimumRequiredNewportVersionDismissed: (state) => {
            state.hasMinimumRequiredNewportVersionDismissed = true;
        },
    },
});

export const newportAppReducer = newportAppSlice.reducer;

export const {
    setVersionDetails,
    dismissHasMinimumRecommendedNewportVersion,
    dismissHasMinimumRequiredNewportVersionDismissed,
} = newportAppSlice.actions;

export const selectNewportAppState = (state: State) => state.newportApp;

export const selectNewportVersionDetails = (state: State) =>
    selectNewportAppState(state).versionDetails;

export const selectShowBelowRequiredWarning = (state: State) => {
    const { hasMinimumRequiredNewportVersionDismissed } =
        selectNewportAppState(state);
    const versionDetails = selectNewportVersionDetails(state);

    return (
        versionDetails &&
        !versionDetails.hasMinimumRequiredNewportVersion &&
        !hasMinimumRequiredNewportVersionDismissed
    );
};

export const selectShowBelowRecommendeWarning = (state: State) => {
    const { hasMinimumRecommendedNewportVersionDismissed } =
        selectNewportAppState(state);
    const versionDetails = selectNewportVersionDetails(state);

    return (
        versionDetails &&
        !versionDetails.hasMinimumRecommendedNewportVersion &&
        !hasMinimumRecommendedNewportVersionDismissed
    );
};
